import { theme } from '@prose-ui';
import { legacyTheme, styled } from '@prose-ui/legacy';
import { makeStyles } from 'legacyStyles';

import { Faq } from 'Blocks/Faq';

import { faq } from 'assets/content/landingPages/supplements';

const Root = styled.section`
  padding: 96px 0 113px;

  background-color: ${theme.colors.supps[200]};
  border-bottom: 2px solid ${theme.colors.primary[400]};

  ${legacyTheme.breakpoints.up('sm')} {
    padding: 112px 25px 90px;
  }

  ${legacyTheme.breakpoints.up('md')} {
    padding: 123px 25px 180px;
  }
`;

// Override FAQ style
const useStyles = makeStyles({
  faq: {
    margin: 0,
    maxWidth: 'none',
  },
  faqTitle: {
    marginBottom: '42px',

    '& h2': {
      fontFamily: `${legacyTheme.typography.simplonNorm}`,

      [legacyTheme.breakpoints.up('sm')]: {
        fontSize: '60px',
        lineHeight: 1.13,
        letterSpacing: 'normal',
      },
    },
  },
  faqText: {
    '& p': {
      color: `${theme.colors.primary[400]}`,
    },
  },
});

export const ModuleFAQ = () => {
  const { classes } = useStyles();
  const { questions: faqQuestions } = faq;

  return (
    <Root data-testid="supplements-landing-module">
      <Faq
        backgroundColor={theme.colors.supps[200]}
        classes={{
          root: classes.faq ?? '',
          half: classes.faqTitle ?? '',
          collapse: classes.faqText ?? '',
        }}
        questions={faqQuestions}
        title={faq.title}
      />
    </Root>
  );
};
